import { render, staticRenderFns } from "./OverallAssessmentHeader.vue?vue&type=template&id=60ebd44c"
import script from "./OverallAssessmentHeader.vue?vue&type=script&lang=ts"
export * from "./OverallAssessmentHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports